import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { WeezHeader } from '@weezevent/nacre';
import { TemplateDetails } from '@weezevent/templar';

const TemplateInformation = ({ id, organizationId = 0 }) => {
    const { t } = useTranslation();
    const history = useHistory();

    return (
        <>
            <WeezHeader
                title={t('sauron.emails.templates.brandkits.templates')}
                backLink={{
                    onClick: () => {
                        history.push('/emails/templates/templates');
                    }
                }}
            />
            <TemplateDetails id={id} organizationId={organizationId} />
        </>
    );
};

export default TemplateInformation;
